import { render, staticRenderFns } from "./CardAdvanceEmployeewait.vue?vue&type=template&id=ceb07ae0&"
import script from "./CardAdvanceEmployeewait.vue?vue&type=script&lang=js&"
export * from "./CardAdvanceEmployeewait.vue?vue&type=script&lang=js&"
import style0 from "./CardAdvanceEmployeewait.vue?vue&type=style&index=0&id=ceb07ae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports